class HeroCarousel {
  constructor(element) {
    this.container = element;
    this.slides = Array.from(this.container.querySelectorAll('.hero-carousel__slide'));
    this.dots = Array.from(this.container.querySelectorAll('.hero-carousel__dot'));
    this.prevBtn = this.container.querySelector('.hero-carousel__arrow--prev');
    this.nextBtn = this.container.querySelector('.hero-carousel__arrow--next');
    this.currentIndex = 0;
    this.autoplay = this.container.dataset.autoplay === 'true';
    this.autoplaySpeed = parseInt(this.container.dataset.autoplaySpeed, 10) || 5000;
    this.timer = null;

    if (this.container.classList.contains('hero-carousel--height-full-screen')) {
      this.updateViewportOffset = this.updateViewportOffset.bind(this);
      this.updateViewportOffset();
      window.addEventListener('resize', this.updateViewportOffset);
      window.addEventListener('load', this.updateViewportOffset);
    }

    if (this.slides.length <= 1) return;

    this.bindEvents();
    if (this.autoplay) this.startAutoplay();
  }

  updateViewportOffset() {
    const rect = this.container.getBoundingClientRect();
    const offset = Math.max(0, Math.round(rect.top + window.scrollY));
    this.container.style.setProperty('--hero-viewport-offset', `${offset}px`);
  }

  bindEvents() {
    if (this.nextBtn) {
      this.nextBtn.addEventListener('click', () => {
        this.goTo(this.currentIndex + 1);
        this.restartAutoplay();
      });
    }
    if (this.prevBtn) {
      this.prevBtn.addEventListener('click', () => {
        this.goTo(this.currentIndex - 1);
        this.restartAutoplay();
      });
    }
    this.dots.forEach((dot, index) => {
      dot.addEventListener('click', () => {
        this.goTo(index);
        this.restartAutoplay();
      });
    });

    this.container.addEventListener('mouseenter', () => this.stopAutoplay());
    this.container.addEventListener('mouseleave', () => {
      if (this.autoplay) this.startAutoplay();
    });
  }

  goTo(index) {
    const total = this.slides.length;
    this.currentIndex = ((index % total) + total) % total;

    this.slides.forEach((slide, i) => {
      const isActive = i === this.currentIndex;
      slide.classList.toggle('is-active', isActive);

      const video = slide.querySelector('video');
      if (video) {
        if (isActive) {
          video.play().catch(() => {});
        } else {
          video.pause();
        }
      }
    });
    this.dots.forEach((dot, i) => {
      dot.classList.toggle('is-active', i === this.currentIndex);
    });
  }

  startAutoplay() {
    this.stopAutoplay();
    this.timer = setInterval(() => {
      this.goTo(this.currentIndex + 1);
    }, this.autoplaySpeed);
  }

  stopAutoplay() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  }

  restartAutoplay() {
    if (this.autoplay) this.startAutoplay();
  }
}

document.querySelectorAll('.hero-carousel').forEach((el) => new HeroCarousel(el));

document.querySelectorAll('.hero-carousel__popup-overlay').forEach((overlay) => {
  const section = overlay.closest('.hero-carousel');
  const openBtn = section ? section.querySelector('[data-hero-popup-open]') : null;
  const closeBtn = overlay.querySelector('[data-hero-popup-close]');

  const openPopup = () => {
    overlay.hidden = false;
    requestAnimationFrame(() => overlay.classList.add('is-visible'));
    document.body.style.overflow = 'hidden';
  };

  const closePopup = () => {
    overlay.classList.remove('is-visible');
    document.body.style.overflow = '';
    setTimeout(() => {
      overlay.hidden = true;
    }, 200);
  };

  if (openBtn) {
    openBtn.addEventListener('click', openPopup);
  }
  if (closeBtn) {
    closeBtn.addEventListener('click', closePopup);
  }
  overlay.addEventListener('click', (event) => {
    if (event.target === overlay) closePopup();
  });
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && !overlay.hidden) closePopup();
  });

  // If the form was already submitted (server re-render with success/error), show the popup open
  if (overlay.querySelector('.hero-carousel__popup-success') || overlay.querySelector('.hero-carousel__popup-error')) {
    openPopup();
  }
});
